import { Serializers } from "@megaron/serializers";

export const priceCurrentStatuses = ["active", "expired", "upcoming"] as const;
export type PriceCurrentStatus = (typeof priceCurrentStatuses)[number];

export const priceSortFields = [
  "priceList",
  "itemId",
  "itemName",
  "gtin",
  "value",
  "activeFrom",
  "activeUntilExclusive",
  "modifiedAt",
] as const;
export type PriceSortField = (typeof priceSortFields)[number];

export const priceListsFiltersSerializer = Serializers.object({
  priceLists: Serializers.string.array(),
  items: Serializers.string.array(),
  searchText: Serializers.string,
  currentStatus: Serializers.stringOneOf(...priceCurrentStatuses).array(),
  activeOn: Serializers.dateOnly,
  sort: Serializers.sortFilter(priceSortFields),
}).partial();
